import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { ICarVariantOption, IOptions } from '../../../interface/new-car.interface';
import { IoChevronDown } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import ModalMobileNativeScroll from '../ModalMobileNativeScroll';
import ArrowForward from '../Icons/ArrowForward';

interface Props {
  id?: string;
  label?: string;
  labelClassname?: string;
  placeholder?: string;
  headerModalTitle?: string;
  selectedOption: IOptions;
  onSelect: (val: IOptions) => void;
  disabled?: boolean;
  required?: boolean;
  manualTypeCarList: ICarVariantOption[];
  automaticTypeCarList: ICarVariantOption[];
}

function ContentModal({
  manualTypeCarList = [],
  automaticTypeCarList = [],
  selected,
  setVisible,
  selectedType = 'otomatis',
  setSelectedType,
  handleOptionSelect,
}: {
  manualTypeCarList: ICarVariantOption[];
  automaticTypeCarList: ICarVariantOption[];
  selected: IOptions;
  setVisible: (val: boolean) => void;
  selectedType: string;
  setSelectedType: (val: string) => void;
  handleOptionSelect: (val: IOptions) => void;
}) {
  const [selectedContainer, setSelectedContainer] = React.useState<IOptions>(selected);
  const carTypeList = selectedType === 'otomatis' ? automaticTypeCarList : manualTypeCarList;

  return (
    <div className="h-full">
      <div className="max-h-[calc(100vh-156px)]">
        <div className="w-full flex items-center justify-center mt-3 px-5">
          <button
            className={`w-full text-center rounded py-3 font-semibold text-xs ${selectedType === 'otomatis' ? 'bg-[#231F20] text-[#FFFEFE]' : 'bg-[#F4F4F4] text-[#231F20]'}`}
            onClick={() => setSelectedType('otomatis')}
          >
            OTOMATIS
          </button>
          <button
            className={`w-full text-center rounded py-3 font-semibold text-xs ${selectedType === 'manual' ? 'bg-[#231F20] text-[#FFFEFE]' : 'bg-[#F4F4F4] text-[#231F20]'}`}
            onClick={() => setSelectedType('manual')}
          >
            MANUAL
          </button>
        </div>

        <ul className="thin-scrollbar overflow-y-auto text-reliableBlack80 max-h-[calc(100vh-155px)] mt-2">
          {carTypeList?.length ? (
            carTypeList.map((option, index) => (
              <div
                className="py-4 flex gap-4 items-center border-b-[0.5px] px-5"
                onClick={() => setSelectedContainer(option)}
                key={index}
              >
                <input
                  type="radio"
                  name={`name-${option?.value}-${index}`}
                  value={option?.value}
                  checked={selectedContainer ? selectedContainer?.value === option?.value : false}
                  onChange={() => setSelectedContainer(option)}
                  className="h-4 w-4 text-red-500 focus:ring-red-500 cursor-pointer accent-supportiveRed"
                />
                <li key={index} className="ursor-pointer text-sm text-[#231F20] font-medium">
                  {option?.label}
                  {!option?.isHidePrice && option?.price && (
                    <p className="text-supportiveRed">({option.price})</p>
                  )}
                </li>
              </div>
            ))
          ) : (
            <li className="px-4 py-2 text-center">Pilihan tidak tersedia</li>
          )}
        </ul>
      </div>

      <button
        type="button"
        className="fixed bottom-0 left-0 w-full flex gap-2 justify-end disabled:bg-reliableBlack20 bg-supportiveRed items-center p-4 text-white text-base font-bold"
        onClick={() => {
          handleOptionSelect(selectedContainer);
          setVisible(false);
        }}
        disabled={!selectedContainer}
      >
        SIMPAN <ArrowForward color="#ffffff" size={24} />
      </button>
    </div>
  );
}

function DropSelectCarType({
  id = '',
  label = '',
  labelClassname,
  placeholder,
  headerModalTitle = '',
  selectedOption,
  onSelect,
  required = false,
  disabled = false,
  manualTypeCarList = [],
  automaticTypeCarList = [],
}: Props) {
  const dropdownRef = useRef(null);
  const inputDropdownRef = useRef(null);
  const { isLargeScreen } = useSelector((item: IRootState) => item.page) || {
    isLargeScreen: false,
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [selectedType, setSelectedType] = useState<string>('otomatis');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        isDropdownOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        e.target !== inputDropdownRef.current
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    if (!isLargeScreen) {
      setIsModalOpen(false);
    }
  }, [isLargeScreen]);

  const handleOptionSelect = (option) => {
    if (!option || option?.value === selectedOption?.value) return;

    onSelect(option);
    setIsDropdownOpen(false);
  };

  const carTypeList = selectedType === 'otomatis' ? automaticTypeCarList : manualTypeCarList;

  return (
    <>
      <div className="relative">
        {label && (
          <label className={`${labelClassname}`}>
            {label}
            {required && <span className="text-red-500"> *</span>}
          </label>
        )}

        {isLargeScreen && (
          <>
            <div
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center cursor-pointer"
            >
              <input
                id={id}
                ref={inputDropdownRef}
                type="text"
                value={selectedOption?.label}
                className={`w-full outline-none px-4 py-2 border-b border-reliableBlack30 focus:border-reliableBlack60 lg:px-5 lg:py-3 ${disabled ? 'bg-reliableBlack10 placeholder:text-reliableBlack50 text-reliableBlack50' : 'bg-reliableBlack3 placeholder:text-reliableBlack60 text-reliableBlack cursor-pointer'}`}
                placeholder={placeholder}
                readOnly
                disabled={disabled}
              />

              {/* Handle toggle icon */}
              <span
                className={`absolute right-4 pointer-events-none ${
                  isDropdownOpen
                    ? 'transform rotate-180 transition duration-100 text-reliableBlack80'
                    : 'text-reliableBlack80 transform rotate-0 duration-100'
                }`}
              >
                <IoChevronDown color="#737373" />
              </span>
            </div>

            {isDropdownOpen && (
              <div
                ref={dropdownRef}
                className="absolute w-full z-[100] p-2 pb-4 px-7 left-0 bg-[#FFFFFF] mt-2 shadow rounded border border-[#F4F4F4]"
              >
                <div className="w-full flex items-center justify-center p-1">
                  <button
                    className={`w-full text-center rounded py-3 font-semibold text-sm ${selectedType === 'otomatis' ? 'bg-[#231F20] text-[#FFFEFE]' : 'bg-[#F4F4F4] text-[#231F20]'}`}
                    onClick={() => setSelectedType('otomatis')}
                  >
                    OTOMATIS
                  </button>
                  <button
                    className={`w-full text-center rounded py-3 font-semibold text-sm ${selectedType === 'manual' ? 'bg-[#231F20] text-[#FFFEFE]' : 'bg-[#F4F4F4] text-[#231F20]'}`}
                    onClick={() => setSelectedType('manual')}
                  >
                    MANUAL
                  </button>
                </div>
                <ul className="thin-scrollbar overflow-y-auto max-h-[170px] text-reliableBlack80 bg-white mt-4">
                  {carTypeList?.length ? (
                    carTypeList.map((option, index) => (
                      <li
                        key={index}
                        className={`px-6 py-4 cursor-pointer border-b text-[#333333] flex gap-2 font-medium ${selectedOption?.value === option?.value ? 'bg-[#f5f5f5]' : ''}`}
                        onClick={() => handleOptionSelect(option)}
                      >
                        {option?.label}
                        {!option?.isHidePrice && option?.price && (
                          <p className="text-supportiveRed">({option.price})</p>
                        )}
                      </li>
                    ))
                  ) : (
                    <li className="px-4 py-2 text-center">Pilihan tidak tersedia</li>
                  )}
                </ul>
              </div>
            )}
          </>
        )}

        {!isLargeScreen && (
          <div
            className={`w-full px-5 py-3 border-b border-reliableBlack30 font-medium flex justify-between items-center ${disabled ? 'cursor-not-allowed bg-reliableBlack10 text-reliableBlack50' : 'cursor-pointer bg-[#F8F8F8] text-[#231F20]'}`}
            onClick={() => {
              if (!disabled) setIsModalOpen(true);
            }}
          >
            <span className="text-[#231F20] font-medium">
              {selectedOption?.label ?? placeholder}
            </span>
            <FiChevronDown color="#727272" size={18} />
          </div>
        )}
      </div>

      {isModalOpen && !isLargeScreen && (
        <ModalMobileNativeScroll
          title={headerModalTitle}
          modalClassName={isModalOpen ? '!z-100' : ''}
          visible={isModalOpen}
          bodyClassName="flex flex-col justify-between"
          headerClassName="!mb-0"
          height="h-full"
          onClose={() => setIsModalOpen(false)}
        >
          <ContentModal
            manualTypeCarList={manualTypeCarList}
            automaticTypeCarList={automaticTypeCarList}
            selected={selectedOption}
            setVisible={setIsModalOpen}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            handleOptionSelect={handleOptionSelect}
          />
        </ModalMobileNativeScroll>
      )}
    </>
  );
}

export default DropSelectCarType;
